import type { ComponentType } from 'react'
import { Pressable, Text, View } from 'react-native'
import type { LucideProps } from 'lucide-react-native'
import { colors } from '@chillout/core'

export interface AdminTab<T extends string> {
  key: T
  label: string
  Icon?: ComponentType<LucideProps>
}

interface AdminTabsProps<T extends string> {
  tabs: AdminTab<T>[]
  activeTab: T
  onTabChange: (tab: T) => void
}

export function AdminTabs<T extends string>({ tabs, activeTab, onTabChange }: AdminTabsProps<T>) {
  return (
    <View accessibilityRole="tablist" className="flex-row border-b border-border">
      {tabs.map((tab) => (
        <Pressable
          key={tab.key}
          onPress={() => onTabChange(tab.key)}
          accessibilityRole="tab"
          accessibilityState={{ selected: activeTab === tab.key }}
          accessibilityLabel={tab.label}
          className={`-mb-px mr-2 flex-row items-center gap-2 px-6 pb-3 border-b-2 ${
            activeTab === tab.key ? 'border-accent' : 'border-transparent'
          }`}
        >
          {tab.Icon ? (
            <tab.Icon
              size={18}
              color={activeTab === tab.key ? colors.accent.DEFAULT : colors.text.primary}
              strokeWidth={2}
            />
          ) : null}
          <Text
            className={`text-base font-semibold ${
              activeTab === tab.key ? 'text-accent' : 'text-primary'
            }`}
          >
            {tab.label}
          </Text>
        </Pressable>
      ))}
    </View>
  )
}